export default "__VITE_ASSET__wm1B17re__"